import { RSAA } from 'redux-api-middleware';
import api from '../../api';

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_REQUEST = 'farmakom/recommended_items/LOAD_REQUEST';
const LOAD_SUCCESS = 'farmakom/recommended_items/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/recommended_items/LOAD_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function loadRecommendedItems() {
  const cartId = localStorage.getItem('cartId');
  return {
    [RSAA]: {
      ...api.getRecommendedByCartId(cartId),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  loading: false,
  error: '',
  data: [],
};

export default function recommendedItemsReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    default:
      return state;
  }
}
